module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_05-8969d0ad0b78f03b281780a7cf8c76a4.jpg";